// extracted by mini-css-extract-plugin
export default {"categoryImage":"product-shelf_categoryImage__ZBwDN","productList":"product-shelf_productList__gUFhG"};